import React from 'react';
import CaseStudys from '../index';
import styles from './styles.module.scss';
import Assetglance from '../../../assets/casestudy/assetglance.webp';
import assetglacne1img from '../../../assets/casestudy/assetglacne1img.webp';
import Assetglacne2img from '../../../assets/casestudy/assetglacne2img.webp';
import KumarPhotography from '../../../assets/img/KumarPhotoGraphy.png';
import Mongodbicon from '../../../assets/img/mongodbicon.svg';
import Nodeicon from '../../../assets/img/nodeicon.svg';
import Reacticon from '../../../assets/img/reacticon.svg';
import Expressicon from '../../../assets/img/expressicon.svg';
import Devangi1stimg from '../../../assets/casestudy/Devangi1stimg.webp';
import genuiunimg from '../../../assets/casestudy/genuiunimg.png';
import assetglance3rdimg from '../../../assets/casestudy/assetglance3rdimg.png';
const AssetGlance = () => {
  const caseStudiesB = [
 {
    image: Devangi1stimg,
    title: 'Devangi Atithya',
    category: 'Website Design',
     pagelink:'/devangiAtithya',
    link: ' https://devangiatithya.com/',
  },
   {
    image: genuiunimg,
    title: 'Genuine IT Systems',
    category: 'Website Design',
     pagelink:'/genuineitsystems',
    link: 'https://www.genitsgroup.com/',
  },
];
  const servicesB = [
  { label: 'UI & UX Design', link: 'https://metasoft.ae/services' },
  { label: 'Web Development', link: 'https://metasoft.ae/services' },
  { label: 'Performance Optimization', link: 'https://metasoft.ae/services'},
  { label: 'SEO', link: 'https://metasoftdm.com/marketing-solutions/seo/'},
];
  return (
    <CaseStudys
    caseStudies={caseStudiesB} 
      title="Asset Glance"
      subtitle="Empowering Organizations with Smarter Asset Solutions"
      header='Empowering Organizations with Smarter Asset Solutions'
      websiteUrl='https://assetglance.com/'

      industry="Asset Management System"
   services={servicesB}
      description={
        <>
          <span>Asset Glance</span> is a powerful Asset Management System (AMS) designed to help organizations effectively monitor, track, and maintain their assets throughout their lifecycle. With a focus on improving operational efficiency and reducing asset-related risks, Asset Glance offers features like real-time tracking, maintenance scheduling, and reporting tools. The software is tailored to meet the needs of various industries, providing a scalable and user-friendly solution for smarter asset management.
        </>
      }
      objective={{
        heading: 'Creating an Intuitive Platform That Helps Users Manage Assets Easily and Efficiently',
        content: (
          <>
            <p className={styles.projectText}>
           The objective of the Asset Glance project was to build a comprehensive and scalable Asset Management System that helps organizations gain full control over their physical assets. The aim was to streamline asset tracking, improve lifecycle management, and automate key processes such as maintenance scheduling, depreciation tracking, and inventory control. By reducing manual efforts and minimizing asset-related risks, the software seeks to enhance operational efficiency, ensure data accuracy, and support better resource planning. The project focused on delivering a user-friendly, reliable, and adaptable solution that can cater to the diverse needs of industries such as education, manufacturing, healthcare, and IT.
            </p>

           
          </>
        ),
      }}
      process={{
        heading: "How We Built an Easy-to-Use Asset Management Platform",
        content: (
          <>
            <p className={styles.projectText}>
         The development process for Asset Glance followed a structured and collaborative approach, starting with a detailed requirement analysis to understand the specific needs of asset-heavy organizations. Based on the findings, a feature-rich system architecture was designed, focusing on core modules such as asset registration, tracking, maintenance scheduling, and reporting. The UI/UX design phase emphasized simplicity and usability to ensure smooth navigation and user adoption. Development was carried out in iterative stages, allowing for continuous feedback and improvement. Rigorous testing ensured the software’s performance, security, and reliability across various use cases. Finally, deployment and user training were conducted to ensure a smooth transition into day-to-day operations.
            </p>

         

           
          </>
        ),
      }}
      impact={{
        heading: 'Helping Users Manage Assets More Easily',
        content: (
          <>
            <p className={styles.projectText}>
           The implementation of Asset Glance had a significant impact on improving asset management efficiency within organizations. It enabled real-time tracking and better visibility of assets, which helped reduce losses, optimize resource utilization, and cut down on unnecessary purchases. Automated maintenance scheduling and reporting minimized downtime and extended asset lifecycles. By centralizing asset data, the software improved accountability and supported informed decision-making across departments. Overall, Asset Glance empowered organizations to manage their assets with greater control, accuracy, and confidence.
            </p>
           
           
          </>
        ),
      }}
       conclusion={{
        heading: 'Wrapping Up the Project',
        content: (
          <>
            <p className={styles.projectText}>
       In conclusion, Asset Glance successfully delivers an easy-to-use and efficient platform that simplifies asset management for users. The thoughtful design and reliable features help businesses keep track of their assets with accuracy and ease. This software not only improves productivity but also builds trust by providing clear and accessible information. Overall, Asset Glance stands out as a valuable tool that supports better decision-making and smoother operations.
            </p>
           
          </>
        ),
      }}
      heroImage={Assetglance} // Add the hero image
      projectImage={assetglacne1img}
       projectImage2={Assetglacne2img}
           projectImage3={assetglance3rdimg}
       // Add the project image
      technologies={[
           { name: 'MongoDB', icon: Mongodbicon },
        { name: 'Node.js', icon: Nodeicon },
        { name: 'React', icon: Reacticon },
        { name: 'Express.js', icon: Expressicon },
      ]} // Add the technologies used
      timescale="On-going" // Add the timescale
      launchDate="Soon" // Add the launch date
    />
  );
};

export default AssetGlance;